import { Action } from '@ngrx/store';

export enum RegionMemberActionTypes {
  ReadCompanyMember = '[RegionMember] Read Company Member',
  ReadCompanyMemberSuccess = '[RegionMember] Read Company Member Success',
  ReadCompanyMemberFail = '[RegionMember] Read Company Member Fail',
  UpdateCompanyMember = '[RegionMember] Update Company Member',
  UpdateCompanyMemberFail = '[RegionMember] Update Company Member Fail',
  ActivateCompanyMember = '[RegionMember] Activate Company Member',
  ActivateCompanyMemberFail = '[RegionMember] Activate Company Member Fail',
  CheckCompanyMember = '[RegionMember] Check Company Member',
  CheckCompanyMemberSuccess = '[RegionMember] Check Company Member Success',
  CheckCompanyMemberFail = '[RegionMember] Check Company Member Fail',
}

export class ReadCompanyMember implements Action {
  readonly type = RegionMemberActionTypes.ReadCompanyMember;
  constructor(public payload: any = null ) {}
}

export class ReadCompanyMemberSuccess implements Action {
  readonly type = RegionMemberActionTypes.ReadCompanyMemberSuccess;
  constructor(public payload: any ) {}
}

export class ReadCompanyMemberFail implements Action {
  readonly type = RegionMemberActionTypes.ReadCompanyMemberFail;
}

export class UpdateCompanyMember implements Action {
  readonly type = RegionMemberActionTypes.UpdateCompanyMember;
  constructor(public payload: any = null ) {}
}

export class UpdateCompanyMemberFail implements Action {
  readonly type = RegionMemberActionTypes.UpdateCompanyMemberFail;
}

export class ActivateCompanyMember implements Action {
  readonly type = RegionMemberActionTypes.ActivateCompanyMember;
  constructor(public payload: any = null ) {}
}

export class ActivateCompanyMemberFail implements Action {
  readonly type = RegionMemberActionTypes.ActivateCompanyMemberFail;
}
export class CheckCompanyMember implements Action {
  readonly type = RegionMemberActionTypes.CheckCompanyMember;
  constructor(public payload: any = null ) {}
}

export class CheckCompanyMemberFail implements Action {
  readonly type = RegionMemberActionTypes.CheckCompanyMemberFail;
}

export type RegionMemberActions = ReadCompanyMember
  | ReadCompanyMemberSuccess
  | ReadCompanyMemberFail
  | UpdateCompanyMember
  | UpdateCompanyMemberFail
  | ActivateCompanyMember
  | ActivateCompanyMemberFail
  | CheckCompanyMember
  | CheckCompanyMemberFail;
